// src/components/Dashboard.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import ProductList from "./ProductList";
import AddProductForm from "./AddProductForm";
import SalePOPUP from "./SalePOPUP";
import { API_BASE_URL } from "../../config";
import Header from "../Header";

const Dashboard = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const { logout } = useAuth();
  const [isRole, setIsRole] = useState("");

  const [savedData, setSavedData] = useState([]);
  const [Loancustomerssuggestions, setLoancustomerssuggestions] = useState([]);
  const [banksavedData, setbankSavedData] = useState([]);
  const [bankStatement, setbankStatement] = useState([]);
  const [expineseData, setExpinesedData] = useState([]);
  const [products, setProducts] = useState([]);
  const [filterUpdated, setFilterUpdated] = useState(true);
  const [previous_day_total, setPrevious_day_total] = useState(0);
  const [quickAdds, setQuickAdds] = useState(null);
  const [quickAddTotals, setQuickAddTotals] = useState(null);

  const navigate = useNavigate(); // Call useNavigate to get navigate function

  const [credentials] = useState({
    token: localStorage.getItem("authToken"),
  });

  const [credentialsfilter,credentialsfilternew] = useState({
    token: localStorage.getItem("authToken"),
 });

 const [product,setProduct] = useState({
    token: localStorage.getItem("authToken"),
    oil_kg: '',
    oil_ltr: '',
    oil_bottle: '',
    cake: '',
    groundnut: '',
    oil_total_amount: '',
    groundnut_total_amount: '',
    cake_total_amount: '',
    grandTotal: '',
 });

 
  // Fetch products from the API
  const fetchfirstdata = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/mainreading`,
        credentialsfilter,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      if (response.data.status) {
        //console.log('productproductproduct ',response.data.data);
        //setProducts(response.data.data);
        setSavedData(response.data.namesuggestions);
        setLoancustomerssuggestions(response.data.Loancustomerssuggestions);
        setbankSavedData(response.data.banksuggestions);
        setbankStatement(response.data.bankStatement);
        setExpinesedData(response.data.expinesesuggestions);
        setPrevious_day_total(response.data.previous_day_total);
        setQuickAdds(response.data.quickAdds || null);
        setQuickAddTotals(response.data.quickAddTotals || null);
        setProduct((prev) => ({
       ...prev,
  'oil_kg': response.data.data.oil_kg,
  'oil_ltr': response.data.data.oil_ltr,
  'oil_bottle_1l': response.data.data.oil_bottle_1l || [],  // Add this
  'oil_bottle_5l': response.data.data.oil_bottle_5l || [],  // Add this
  'oil_bottle_15l': response.data.data.oil_bottle_15l || [], // Add this
  'oil_bottle': response.data.data.oil_bottle, // Keep this for backward compatibility if needed
  'cake': response.data.data.cake,
  'groundnut': response.data.data.groundnut,
  'oil_total_amount': response.data.data.oil_total_amount,
  'groundnut_total_amount': response.data.data.groundnut_total_amount,
  'cake_total_amount': response.data.data.cake_total_amount,
  'grandTotal': response.data.data.grandTotal,
}));
      }
    } catch (err) {
      if (err?.response?.status === 401 || err?.response?.status === 403) {
        logout();
        navigate("/");
      } else {
        console.error("mainreading error:", err?.response?.data || err?.message);
      }
    }
  };
  const fetchProducts = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/getmanagerreading`,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      if (response.data.status) {
        setProducts(response.data.data);
      } else {
      }
    } catch (err) {
      if (err?.response?.status === 401 || err?.response?.status === 403) {
        logout();
        navigate("/");
      } else {
        console.error("getmanagerreading error:", err?.response?.data || err?.message);
      }
    }
  };


  useEffect(() => {
    if (filterUpdated) {
      const authState = localStorage.getItem("authToken");
      if (authState) {
        fetchfirstdata();
        setIsLoggedIn(true);
        setFilterUpdated(false);
      }
    }
  }, [filterUpdated]); // Empty dependency array means this effect runs once on mount

  useEffect(() => {
      const authState = localStorage.getItem("authToken");
      if (authState) {
        fetchProducts();
        setIsLoggedIn(true);
      }
      const role = localStorage.getItem("role");
      if (role) {
        setIsRole(role);
      }
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <>
      <Header />
      <div className="du-detils">
        <div className="container">
          <div className="col-md-12">

            
            {(isRole === "ADMIN" || isRole === "MANAGER") && (
              <Link>
                <SalePOPUP/>
              </Link>
            )}
            
          </div>
          <AddProductForm
            credentialsfilter={credentialsfilter}
            credentialsfilternew={credentialsfilternew}
            product={product}
            setProduct={setProduct}
            isLoggedIn={isLoggedIn}
            setFilterUpdated={setFilterUpdated}
            savedData={savedData}
            Loancustomerssuggestions={Loancustomerssuggestions}
            banksavedData={banksavedData}
            expineseData={expineseData}
            previous_day_total={previous_day_total}
            bankStatement={bankStatement}
            quickAdds={quickAdds}
          />
          {isLoggedIn ? (
            <ProductList
              products={products}
            />
          ) : (
            ""
          )}
        </div>
      </div>
      <Header />
    </>
  );
};
export default Dashboard;